module.exports = __webpack_public_path__ + "img/eye.bc45c926.svg";